export const SalesLogType = Object.freeze({
  Wholesale: "WHOLESALE",
  Retail: "RETAIL",

  getDisplayText(typeValue) {
    const displayTexts = {
      WHOLESALE: "Wholesale",
      RETAIL: "Retail",
    };
    return displayTexts[typeValue];
  },

  getAllValues() {
    return Object.entries(this)
      .filter(([key, value]) => typeof value === "string")
      .map(([key, value]) => value);
  },
});
